import { render, staticRenderFns } from "./SalaryDetail.vue?vue&type=template&id=d193a000"
import script from "../../controllers/salary/salary-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/salary/salary-detail.js?vue&type=script&lang=js&external"
import style0 from "./SalaryDetail.vue?vue&type=style&index=0&id=d193a000&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports